var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB3Convector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 26H19v-4h38v4zm0 4H19v4h38v-4zm0 8H19v4h38v-4zm8-21v42a4 4 0 01-4 4H15a4 4 0 01-4-4V17a4 4 0 014-4h46a4 4 0 014 4zm-4 0H15v42h46V17z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B3_Convector.12659be2.svg";
export { SvgB3Convector as ReactComponent };